import React from 'react';
import { ArrowRight, CheckCircle2, Phone } from 'lucide-react';
import { services, business } from '../data/siteData';
import { PageHeader } from './About';

export default function Services() {
  return (
    <div>
      <PageHeader
        title="Our Services"
        subtitle="Specialized asphalt paving, seal coating, and crack sealing across AB & SK."
        crumb="Services"
      />

      <section className="max-w-7xl mx-auto px-6 py-20">
        <div className="space-y-20">
          {services.map((s, i) => (
            <div
              key={s.id}
              id={s.id}
              className={`grid lg:grid-cols-2 gap-10 lg:gap-16 items-center ${
                i % 2 === 1 ? 'lg:[&>div:first-child]:order-2' : ''
              }`}
            >
              <div className="img-zoom rounded-xl overflow-hidden shadow-2xl">
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-[420px] object-cover"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div>
                <div className="text-amber-600 font-mono font-bold text-xs mb-2 tracking-widest">
                  SERVICE 0{i + 1}
                </div>
                <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 leading-tight">
                  {s.title}
                </h2>
                <div className="w-16 h-1 bg-amber-500 my-5" />
                <p className="text-slate-600 leading-relaxed">{s.description}</p>
                <ul className="mt-6 grid sm:grid-cols-2 gap-3">
                  {s.bullets.map((b) => (
                    <li key={b} className="flex items-start gap-2">
                      <CheckCircle2 size={18} className="text-amber-500 mt-0.5 shrink-0" />
                      <span className="text-slate-700 text-sm">{b}</span>
                    </li>
                  ))}
                </ul>
                <div className="mt-7 flex gap-3 flex-wrap">
                  <a
                    href={`tel:${business.phoneRaw}`}
                    className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-400 text-slate-900 font-bold px-6 py-3 rounded-md shadow-md transition-all"
                  >
                    Get a Quote <ArrowRight size={16} />
                  </a>
                  <a
                    href={`tel:${business.phoneRaw}`}
                    className="inline-flex items-center gap-2 bg-slate-900 hover:bg-slate-800 text-white font-bold px-6 py-3 rounded-md transition-colors"
                  >
                    <Phone size={16} /> Call Now
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA banner */}
      <section className="bg-slate-900 text-white">
        <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-3 gap-6 items-center">
          <div className="md:col-span-2">
            <h3 className="text-2xl md:text-3xl font-extrabold">
              Not sure which service you need?
            </h3>
            <p className="text-slate-400 mt-2">
              Our specialists will inspect your property and recommend the most cost-effective
              solution—free of charge.
            </p>
          </div>
          <div className="flex md:justify-end">
            <a
              href={`tel:${business.phoneRaw}`}
              className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-400 text-slate-900 font-bold px-7 py-3.5 rounded-md shadow-md transition-colors"
            >
              <Phone size={16} /> Call {business.phone}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
